import React, { useState, useEffect } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import MaterialTypography from "../../components/MaterialTypography";
import { Card, CardHeader, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import MaterialButton from "../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import BASEURL from "../Utils/Baseurl";
import axios from "axios";
import { useUserDetails } from "../../context/auth";
const Tax = () => {
  const navigate = useNavigate();
  const { setTaxView, setTaxEdit, setviewcomponent, AccessData } =
    useUserDetails();
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });

  const [data, setData] = useState([]);
  const [taxList, settaxList] = useState([]);

  useEffect(() => {
    getTaxDetails();
  }, []);

  const taxListTable = {
    columns: [
      {
        field: "slabName",
        headerName: "Slab Name",
        width: 200,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "serialNumber",
        headerName: "S. No",
        width: 200,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "fromAmount",
        headerName: "From Amount",
        width: 200,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "toAmount",
        headerName: "To Amount",
        width: 200,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "deductionPercentage",
        headerName: "Percentage of Deduction",
        width: 250,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
    ],
    rows: taxList,
  };

  const handleNewtax = () => {
    navigate("/tax/add-tax", { state: data });
    setTaxView(false);
    setTaxEdit(false);
    setviewcomponent(false);
  };

  const onEmployeeListClick = (e) => {
    setTaxView(true);
    setTaxEdit(true);
    setviewcomponent(true);
    if (e?.id) {
      navigate(`/tax/add-tax?id=${e?.id}`);
    }
  };

  const getTaxDetails = async () => {
    const query = `
         query allTaxConfigurations{ 

  allTaxConfigurations { 

    success 

    message 

    data { 

      id 

      slabName 

      slabs { 

        order 

        fromAmount 

        toAmount 

        percentage 

      } 

    } 

  } 

} 
   `;

    try {
      setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // Extract Employee data from the response
      const taxList = response.data.data.allTaxConfigurations.data;
      const rows = taxList.flatMap((item) =>
        item.slabs.map((slab, index) => ({
          id: `${item.id}-${index + 1}`,
          slabName:
            index === 0
              ? item.slabName === "NEW_TAX_REGIME"
                ? "New Tax Regime"
                : "Old Tax Regime"
              : "",
          serialNumber: slab.order,
          fromAmount: slab.fromAmount,
          toAmount: slab.toAmount ?? "Above",
          deductionPercentage: `${slab.percentage}%`,
        }))
      );
      setData(taxList);
      settaxList(rows);
      setPageState({ ...pageState, loading: false, state: "success" });
    } catch (error) {
      console.error("ResponseError:", error);
      setPageState({
        ...pageState,
        loading: false,
        error: true,
        message: error.message,
      });
    }
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Tax list
                </MaterialTypography>
              </Stack>
              {AccessData &&
                Array.isArray(AccessData) &&
                AccessData.some(
                  (item) => item.component === "AddTax" && item.can_access
                ) && (
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={() => handleNewtax()}
                  >
                    Tax
                  </MaterialButton>
                )}
            </Stack>
          }
        />
        <MaterialDataGrid
          customHeight={550}
          rows={taxListTable.rows}
          columns={taxListTable.columns}
          checkboxSelection={false}
          isSelectable={false}
          onRowClick={onEmployeeListClick}
          loading={pageState.loading}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No Tax found
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  You have not yet add any Tax details. Click on the "Add Tax"
                  button to start adding salary structure details.
                </MaterialTypography>
              </Stack>
            ),
          }}
        />
      </Card>
    </DashboardLayout>
  );
};

export default Tax;
